import Layout from './Layout/pages/LayoutComponent';

export default Layout;